<template>
  <div class="info-table-height">
    <table class="table table-hover table-border">
      <caption class="table-caption">
        <span class="little-title">{{ tableTitle }}</span><a href="purchase.html"
                                                             class="pull-right bid-info-span">更多&gt;</a>
        <ul class="list-basic-settings classify-List">
          <li v-for="(item,index) in tableContent"><span class="bid-info-span" @click="toggle(index)"
                                                         :class="{active: active == index}">{{ item }}</span></li>
        </ul>
      </caption>
      <tbody class='show-limit'>
      <template v-if="infos && infos instanceof Array">
        <tr v-for="info in infos" class="normal" @click="seeDetails(info)">
          <td width="12%">
            <template v-if="info.messageType == '招标公告'">
              <span class="state state-bid">{{info.messageType}}</span>
            </template>

            <template v-else-if="info.messageType == '竞价公告'">
              <span class="state state-other">{{info.messageType}}</span>
            </template>

            <template v-else-if="info.messageType == '招标'">
              <span class="state state-enquiry">{{info.messageType}}</span>
            </template>

            <template v-else-if="info.messageType == '中标通知'">
              <span class="state state-bidding">{{info.messageType}}</span>
            </template>

            <template v-else>
              <span class="state state-other">{{info.messageType}}</span>
            </template>
          </td>
          <td width="25%" class="limitText" :title="info.messageTitle">
            <div class="setMargin">{{info.messageTitle}}</div>
          </td>
          <td width="28%" class="limitText" :title="info.messageContent">
            <div class="setMargin">{{ datatype=="area" ? info.purOrgName : info.messageContent}}</div>
          </td>
          <!--<button class="btn action btn-details" @click="seeDetails(info)">查看详情</button>-->
          <template v-if="info.status">
            <td width="14%" class="btn-action">
              <template v-if=" info.status==='1' ">
                <span>报名未开始</span>
              </template>
              <template v-else-if=" info.status==='3' ">
                <span>报名已结束</span>
              </template>
              <template v-else-if=" info.status==='-1' ">
                  <span>招标已结束</span>
               </template>
               <template v-else-if=" info.status==='4' ">
                 <span>投标进行中</span>
                </template>
               <template v-else-if=" info.status==='5' ">
                <span>投标已结束</span>
               </template>
              <template v-else>
                <span>报名进行中</span>
              </template>
            </td>
          </template>
          <template v-else>
            <td width="14%" class="btn-action">
              <template v-if=" now < timeFormat(info.publishTime) ">
                <span>报名未开始</span>
              </template>
              <template v-else-if=" now > timeFormat(info.deadline) ">
                <span>报名已结束</span>
              </template>
              <template v-else>
                <span>报名进行中</span>
              </template>
            </td>
          </template>
          <td width="21%" class="td-text-right"><span id="setMargin">截止时间：<br>{{info.deadline}}</span></td>
        </tr>
        <template v-if="infos.length < 6">
          <tr v-for="info in (6-infos.length)" class="supplement">
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </template>
      </template>
      <template v-else>
        <p class="error-handling">暂无数据</p>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
/*eslint-disable*/
  import {apiLinks} from '../api/links.js'
  import _ from 'lodash'

  export default {
    name: 'infotable',
    data () {
      return {
        materialList: [],
        innercode: [],
        now: new Date().getTime(),
        active: '',
        infos: '',
        status: '',
        url: '',
        currentPageUrl: apiLinks.infoTable[this.which][0]
      }
    },
    props: {
      tableTitle: '',
      tableContent: '',
      which: '',
      datatype: ''
    },
    created: function () {
      if (this.tableTitle === '按类别查看') {
        this.fetchMateriaClass()
      }
      this.getCustomers(this.currentPageUrl)
    },
    filters: {
      cutStr: function (str) {
        if (!str) return ''
        let abortDate = ''
        abortDate = str.split('-')
        let abortDay = ''
        abortDay = abortDate[abortDate.length - 1].split(' ')
        return abortDate[0] + '年' + abortDate[1] + '月' + abortDay[0] + '日'
      }
    },
    methods: {
      nowUrl: function () {
        this.url = window.location.href
      },
      toggle: function (index) {
        this.active = index
//        console.log(index)
        this.currentPageUrl = apiLinks.infoTable[this.which][0]
        if (this.datatype === 'area' && this.tableContent[index] !== '全部') {
          this.currentPageUrl += ('&purOrgName=' + this.tableContent[index])
        }
        if (this.datatype === 'type' && this.tableContent[index] !== '全部') {
          this.currentPageUrl += ('&innercode=' + this.innercode[index - 1])
//          console.log('进来了')
        }
        this.getCustomers(this.currentPageUrl)
      },
      generateMaterialTree () {
        let list = _.filter(this.materialList, function (data) {
          return data.parentid === 0
        })
        for (let i = 0; i < list.length; i++) {
          this.tableContent.push(list[i].className)
          this.innercode.push(list[i].innercode)
//         this.innercode.push(list[i].id)
        }
      },
      fetchMateriaClass: function () {
        this.$http.jsonp(apiLinks.materiaClass, []).then(function (response) {
          let data = response.body[0]
          if (data.status === 1) {
            this.materialList = data.data
//            console.log(this.materialList)
            this.generateMaterialTree()
          }
        }, function (response) {
          console.log(0)
        })
      },
      getCustomers: function (url) {
//        this.infos = ''
        console.log(url)
        this.$http.jsonp(url, []).then(function (response) {
          this.infos = response.data[0]['result']
          this.status = response.status
        }, function (response) {
          console.log(0)
        })
      },
      seeDetails: function (info) {
//        console.log(info.messageTypeShow)
        debugger
        let url = ''
        var status = parseInt(info.messageState)
        // 数据有问题 先定死成招标公告
        status = 4
        if (info.messageTypeShow === '0') {
          status = 0
        }
        if (info.messageTypeShow === '15') {
          status = 6
        }
        switch (status) {
//        询价
          case 0:
            url = apiLinks.details['inquiryDetails'] + info.msgId+ '&from=nfsn'
            break
          case 1:
            url = apiLinks.details['bidDoc'] + info.msgId+ '&from=nfsn'
            break
//        招标公告
          case 4:
            url = apiLinks.details['bidDetails'] + info.msgId+ '&from=nfsn'
            break
          case 5:
            url = apiLinks.details['bidNotice'] + info.msgId+ '&from=nfsn'
            break
          case 6:
            url = apiLinks.details['jingjia'] + info.msgId+ '&from=nfsn'
            break
          default:
            break
        }
        if (url !== '') {
          window.open(url)
        }
      },
      timeFormat: function (str) {
        return new Date(Date.parse(str.replace(/-/g, '/'))).getTime()
      }
    }
  }
</script>

<style>
  .info-table-height {
    min-height: 392px;
  }

  .classify-List {
    /*display: inline-flex;*/
    display: inline-block;
  }

  .table-caption > span {
    position: relative;
    top: -5px;
  }

  .table-caption > ul {
    position: relative;
    top: 7px;
  }

  /*:root .classify-List {*/
  /*display: inline-block;*/
  /*}*/

  .btn-action {
    text-align: center;
  }

  .btn-action > button {
    width: 80px;
  }

  .btn-details {
    background-color: #F6F6F6;
    color: #555555;
    border: 1px solid #DDDDDD;
    padding: 4px 10px !important;
    margin-left: 13px;
  }

  .limitText {
    white-space: nowrap;
    /*显示省略符号来代表被修剪的文本*/
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .limitText > div {
    width: 200px;
    white-space: nowrap;
    /*显示省略符号来代表被修剪的文本*/
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .table-border {
    min-height: 307px;
  }

  .table-border td {
    height: 57px;
  }

  .error-handling {
    margin-top: 130px;
    text-align: center;
  }

  .state {
    display: inline-block;
    padding: 0 8px;
    /*height: 20px;*/
    text-align: center;
  }

  .state-bid {
    border: 1px solid #92B8E0;
    color: #639cd7;
  }

  .state-enquiry {
    border: 1px solid #FD9B31;
    color: #F58000;
  }

  .state-bidding {
    border: 1px solid #F15A4A;
    color: #F15A4A;
  }

  .state-other {
    border: 1px solid #339966;
    color: #339966;
  }

  .show-limit > tr {
    height: 51px;
  }

  /*.show-limit .setMargin{*/
  /*margin-top: 5px;*/
  /*}*/
  /*#setMargin{*/
  /*margin-top: 5px;*/
  /*}*/
  /*补充*/
  /*.supplement {*/
  /*opacity: 0;*/
  /*}*/

  .table-hover > tbody > .supplement:hover {
    background-color: #FFFFFF;
  }

  .table-hover > tbody > .supplement:first-child {
    border-top: 1px solid #ddd;
  }

  .supplement > td {
    border: none !important;
  }

  .supplement:first-child {
    border-bottom: 1px solid #ddd;
  }

  tr.normal {
    cursor: pointer;
  }

  .td-text-right > span {
    display: inline-block;
    margin-left: 25px;
  }
</style>



// WEBPACK FOOTER //
// info-table.vue?5f90a4de